import { StreamingPlayerTypography } from '@heardis/stream-contracts';
import { useAuthContext } from '../../contexts/AuthContext';
import InfoContainer from './InfoContainer';
import classes from './LoginContainer.module.css';

type LoginContainerProps = {
  backgroundColor: string;
  typography: StreamingPlayerTypography;
};

function LoginContainer({ backgroundColor, typography }: LoginContainerProps) {
  const { signIn } = useAuthContext();

  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const username = formData.get('username') as string;
    const password = formData.get('password') as string;
    signIn({ username, password });
  };

  return (
    <InfoContainer backgroundColor={backgroundColor} typography={typography}>
      <form className={classes.form} onSubmit={handleSubmit}>
        <label className={classes.label} htmlFor="username">
          <small>Username</small>
          <input className={classes.input} size={10} id="username" name="username" type="text" placeholder="Username" autoComplete="username" />
        </label>
        <label className={classes.label} htmlFor="password">
          <small>Password</small>
          <input className={classes.input} id="password" name="password" type="password" placeholder="Password" autoComplete="current-password" />
        </label>
        <button className={classes.submit} type="submit">Sign in</button>
      </form>
    </InfoContainer>
  );
}

export default LoginContainer;
